import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { BLOCKS, Document, INLINES } from '@contentful/rich-text-types'
import { Box, Table, TableBody, TableCell, Typography, TypographyProps } from '@mui/material'

import Anchor from '@ecm/ui/element/Anchor'
import Color from '@ecm/ui/element/Color'

export type ContentfulEnv = {
  contentful: {
    accessToken: string
    previewToken: string
    space: string
  }
}

export const convertToComponent = (
  field?: Document,
  paragraphVariant: TypographyProps['variant'] = 'p2',
  paragraphColor?: TypographyProps['color']
) => {
  if (field) {
    return documentToReactComponents(field, {
      renderNode: {
        // eslint-disable-next-line react/display-name
        [BLOCKS.PARAGRAPH]: (node, next) => (
          <Typography variant={paragraphVariant} color={paragraphColor} whiteSpace="pre-wrap">
            {next}
          </Typography>
        ),
        // eslint-disable-next-line react/display-name
        [BLOCKS.OL_LIST]: (node, next) => (
          <Box
            component="ol"
            sx={{
              ol: {
                listStyleType: 'lower-alpha',
              },
              'ol ol': {
                listStyleType: 'lower-roman',
              },
            }}
          >
            {next}
          </Box>
        ),
        // eslint-disable-next-line react/display-name
        [INLINES.HYPERLINK]: (node, next) => {
          const { uri } = node.data
          return (
            <Anchor
              href={uri}
              external={
                !(
                  uri.startsWith('https://www.earthclassmail.com') ||
                  uri.startsWith('https://help.earthclassmail.com') ||
                  uri.startsWith('https://app.earthclassmail.com')
                )
              }
              variant={paragraphVariant}
            >
              {next}
            </Anchor>
          )
        },
        // eslint-disable-next-line react/display-name
        [BLOCKS.HEADING_1]: (node, next) => (
          <Typography component="h1" variant="h3">
            {next}
          </Typography>
        ),
        // eslint-disable-next-line react/display-name
        [BLOCKS.HEADING_2]: (node, next) => (
          <Typography component="h2" variant="h5">
            {next}
          </Typography>
        ),
        // eslint-disable-next-line react/display-name
        [BLOCKS.HEADING_3]: (node, next) => (
          <Typography component="h3" variant="h6">
            {next}
          </Typography>
        ),
        // eslint-disable-next-line react/display-name
        [BLOCKS.TABLE]: (node, next) => (
          <Table sx={{ maxWidth: '800px', mb: '2em' }}>
            <TableBody>{next}</TableBody>
          </Table>
        ),
        // eslint-disable-next-line react/display-name
        [BLOCKS.TABLE_CELL]: (node, next) => (
          <TableCell
            sx={{
              border: `1px solid ${Color.smoke.normal}`,
              padding: '1em 1em 0 1em',
              verticalAlign: 'top',
            }}
          >
            {next}
          </TableCell>
        ),
      },
    })
  }
  return ''
}
